/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { additionalPrimitives } from './primitives';
const dataVisualization = {
  rose12Primary: additionalPrimitives.rose12,
  rose30Primary: additionalPrimitives.rose30,
  rose45Primary: additionalPrimitives.rose45,
  rose70Primary: additionalPrimitives.rose70,
  rose110Primary: additionalPrimitives.rose110,
  rose35Secondary: additionalPrimitives.rose35,
  rose40Secondary: additionalPrimitives.rose40,
  rose50Secondary: additionalPrimitives.rose50,
  rose57Secondary: additionalPrimitives.rose57,
  rose90Secondary: additionalPrimitives.rose90,
  copper12Primary: additionalPrimitives.copper12,
  copper30Primary: additionalPrimitives.copper30,
  copper45Primary: additionalPrimitives.copper45,
  copper70Primary: additionalPrimitives.copper70,
  copper110Primary: additionalPrimitives.copper110,
  copper35Secondary: additionalPrimitives.copper35,
  copper40Secondary: additionalPrimitives.copper40,
  copper50Secondary: additionalPrimitives.copper50,
  copper57Secondary: additionalPrimitives.copper57,
  copper90Secondary: additionalPrimitives.copper90,
  honey12Primary: additionalPrimitives.honey12,
  honey30Primary: additionalPrimitives.honey30,
  honey45Primary: additionalPrimitives.honey45,
  honey70Primary: additionalPrimitives.honey70,
  honey110Primary: additionalPrimitives.honey110,
  honey35Secondary: additionalPrimitives.honey35,
  honey40Secondary: additionalPrimitives.honey40,
  honey50Secondary: additionalPrimitives.honey50,
  honey57Secondary: additionalPrimitives.honey57,
  honey90Secondary: additionalPrimitives.honey90,
  forest12Primary: additionalPrimitives.forest12,
  forest30Primary: additionalPrimitives.forest30,
  forest45Primary: additionalPrimitives.forest45,
  forest70Primary: additionalPrimitives.forest70,
  forest110Primary: additionalPrimitives.forest110,
  forest35Secondary: additionalPrimitives.forest35,
  forest40Secondary: additionalPrimitives.forest40,
  forest50Secondary: additionalPrimitives.forest50,
  forest57Secondary: additionalPrimitives.forest57,
  forest90Secondary: additionalPrimitives.forest90,
  aurora12Primary: additionalPrimitives.aurora12,
  aurora30Primary: additionalPrimitives.aurora30,
  aurora45Primary: additionalPrimitives.aurora45,
  aurora70Primary: additionalPrimitives.aurora70,
  aurora110Primary: additionalPrimitives.aurora110,
  aurora35Secondary: additionalPrimitives.aurora35,
  aurora40Secondary: additionalPrimitives.aurora40,
  aurora50Secondary: additionalPrimitives.aurora50,
  aurora57Secondary: additionalPrimitives.aurora57,
  aurora90Secondary: additionalPrimitives.aurora90,
  sea12Primary: additionalPrimitives.sea12,
  sea30Primary: additionalPrimitives.sea30,
  sea45Primary: additionalPrimitives.sea45,
  sea70Primary: additionalPrimitives.sea70,
  sea110Primary: additionalPrimitives.sea110,
  sea35Secondary: additionalPrimitives.sea35,
  sea40Secondary: additionalPrimitives.sea40,
  sea50Secondary: additionalPrimitives.sea50,
  sea57Secondary: additionalPrimitives.sea57,
  sea90Secondary: additionalPrimitives.sea90,
  sky12Primary: additionalPrimitives.sky12,
  sky30Primary: additionalPrimitives.sky30,
  sky45Primary: additionalPrimitives.sky45,
  sky70Primary: additionalPrimitives.sky70,
  sky110Primary: additionalPrimitives.sky110,
  sky35Secondary: additionalPrimitives.sky35,
  sky40Secondary: additionalPrimitives.sky40,
  sky50Secondary: additionalPrimitives.sky50,
  sky57Secondary: additionalPrimitives.sky57,
  sky90Secondary: additionalPrimitives.sky90,
  ocean12Primary: additionalPrimitives.ocean12,
  ocean30Primary: additionalPrimitives.ocean30,
  ocean45Primary: additionalPrimitives.ocean45,
  ocean70Primary: additionalPrimitives.ocean70,
  ocean110Primary: additionalPrimitives.ocean110,
  ocean35Secondary: additionalPrimitives.ocean35,
  ocean40Secondary: additionalPrimitives.ocean40,
  ocean50Secondary: additionalPrimitives.ocean50,
  ocean57Secondary: additionalPrimitives.ocean57,
  ocean90Secondary: additionalPrimitives.ocean90,
  violet12Primary: additionalPrimitives.violet12,
  violet30Primary: additionalPrimitives.violet30,
  violet45Primary: additionalPrimitives.violet45,
  violet70Primary: additionalPrimitives.violet70,
  violet110Primary: additionalPrimitives.violet110,
  violet35Secondary: additionalPrimitives.violet35,
  violet40Secondary: additionalPrimitives.violet40,
  violet50Secondary: additionalPrimitives.violet50,
  violet57Secondary: additionalPrimitives.violet57,
  violet90Secondary: additionalPrimitives.violet90,
  plum12Primary: additionalPrimitives.plum12,
  plum30Primary: additionalPrimitives.plum30,
  plum45Primary: additionalPrimitives.plum45,
  plum70Primary: additionalPrimitives.plum70,
  plum110Primary: additionalPrimitives.plum110,
  plum35Secondary: additionalPrimitives.plum35,
  plum40Secondary: additionalPrimitives.plum40,
  plum50Secondary: additionalPrimitives.plum50,
  plum57Secondary: additionalPrimitives.plum57,
  plum90Secondary: additionalPrimitives.plum90,
  stone12Primary: additionalPrimitives.stone12,
  stone30Primary: additionalPrimitives.stone30,
  stone45Primary: additionalPrimitives.stone45,
  stone70Primary: additionalPrimitives.stone70,
  stone110Primary: additionalPrimitives.stone110,
  stone35Secondary: additionalPrimitives.stone35,
  stone40Secondary: additionalPrimitives.stone40,
  stone50Secondary: additionalPrimitives.stone50,
  stone57Secondary: additionalPrimitives.stone57,
  stone90Secondary: additionalPrimitives.stone90
};
export default dataVisualization;